'use client';

import { useEventLeadGate } from '@publishing/hooks/useEventLeadGate';

import { TODAY_CONTACT_PATH, TODAY_SLUG, TODAY_SUBMIT_PATH } from './data';

export function TodayFlowGate({
  children,
  visibleHidden = false,
}: {
  children?: React.ReactNode;
  /** 세션 확인 중 본문 공간을 유지하고 화면에서만 숨긴다. */
  visibleHidden?: boolean;
}) {
  const { isChecking } = useEventLeadGate({
    slug: TODAY_SLUG,
    contactPath: TODAY_CONTACT_PATH,
    resultPath: TODAY_SUBMIT_PATH,
  });

  // submit: 세션 확인 중이거나 리다이렉트 대기 중이면 본문을 렌더링하지 않는다.
  if (isChecking && !visibleHidden) return null;

  // contact: 본문 공간을 유지하고, 세션 확인이 끝나면 숨김만 해제한다.
  if (visibleHidden) {
    return (
      <div style={{ display: 'contents', visibility: isChecking ? 'hidden' : 'visible' }}>
        {children}
      </div>
    );
  }

  // submit: 현재 페이지에 머물러도 되는 경우 본문을 표시한다.
  return <>{children}</>;
}
